import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { PainelService } from 'src/app/services/painel.service'
import { ServerUrlService } from 'src/app/services/server-url.service'
import { PainelType } from '../interfaces/painel'
import { PainelLocalType } from '../interfaces/painelLocal'
import { ParametersService } from 'src/app/services/parameters.service'
import { ActivatedRoute } from '@angular/router'
import { ParameterType } from 'src/app/interfaces/parameter'
import { AdService } from 'src/app/services/ad.service'
import { AdsType } from '../interfaces/ads'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { ToolsService } from 'src/app/services/tools.service'
import { Observable } from 'rxjs'
import { map, startWith } from 'rxjs/operators'
import { PatientQueueSettingsType, OrderTypes } from '../interfaces/patientQueueSettings'
import { PatientQueueSettingsService } from 'src/app/services/patient-queue-settings.service'

@Component({
  selector: 'app-settings-painel',
  templateUrl: './settings-painel.component.html',
  styleUrls: ['./settings-painel.component.scss'],
})
export class SettingsPainelComponent implements OnInit {
  public tabGroupIndex: number = 0
  public params: Array<string> = [
    'SPEECH_LOCAL_ROOM',
    'SPEECH_PREV_PANEL',
    'SPEECH_NAME_PANEL',
    'TOTEM_DIMENSAO',
    'TOTEM_HISTORY',
    'TOTEM_USEPANELS',
    'USAR_LOCAL',
    'EXIBITION_TYPE',
  ]
  public numbers = Array(5).map((x, i) => i)
  public locais: any
  public mode: string = 'all'
  public paineis: Array<PainelType> = []
  public paineisLocais: Array<PainelLocalType> = []
  public empresas: Array<any> = []
  public formPainel!: FormGroup
  public painel: PainelType = {}
  public painelLocal: PainelLocalType = {}
  public showSpinner: boolean = false
  public buttonText: String = 'Confirmar'
  public formPainelLocal!: FormGroup
  public painelLocalMode = 'all'
  public paineisLocaisTemp: Array<PainelLocalType> = []
  public formSettings: FormGroup
  public parametersResponse: Array<ParameterType> = []
  public formAds!: FormGroup
  public formPatientQueueSettings!: FormGroup
  public patientQueueSettings: PatientQueueSettingsType = {}
  public patientQueueSettingsOptions = Object.values(OrderTypes) as OrderTypes[]
  public dataAvailable: boolean = false
  public ad: AdsType = {}
  public ads: Array<AdsType> = []
  public parameters: Array<ParameterType> = []
  public displayTestSrc: string = ''
  public fileStore: File | null = null
  public appearanceEnabled: string = 'false'
  public fontOptions: string[] = [
    'Arial',
    'Verdana',
    'Helvetica',
    'Tahoma',
    'Trebuchet MS',
    'Georgia',
    'Times New Roman',
    'Courier New',
    'Comic Sans MS',
    'Palatino Linotype',
    'Garamond',
    'Lucida Sans Unicode',
    'Arial Black',
    'Impact',
    'Segoe UI',
    'Roboto',
    'Open Sans',
    'Lato',
    'Montserrat',
    'PT Sans',
  ]
  public filteredFontOptions: Observable<string[]> | undefined
  selectedCheckinSchedules: any[] = [];
  selectedAppointmentSchedules: any[] = [];
  carouselSortByCheckin: any[] = []
  carouselSortByAppointment: any[] = []

  constructor(
    private formBuilder: FormBuilder,
    private serverUrl: ServerUrlService,
    private parameterService: ParametersService,
    private route: ActivatedRoute,
    private adService: AdService,
    private sanitizer: DomSanitizer,
    private toolsService: ToolsService,
    private patientQueueSettingsService: PatientQueueSettingsService,
    private painelService: PainelService
  ) {
    this.formSettings = this.formBuilder.group({})
    this.parametersResponse = this.route.snapshot.data['params']
    this.parameterService.getVarSys('USAR_LOCAL').subscribe((varSys) => {
      let aux = varSys[0]
      aux.chave = aux.param
      aux.valor = aux.value
      this.parametersResponse.push(aux)
    })

    if (this.parameterService.appearanceEnabled === 'true') {
      this.appearanceEnabled = 'true'

      this.params.push(
        'TEXT_FONT_FAMILY',
        'PANEL_CLOCK_TEXT_COLOR',
        'PANEL_CLOCK_BACKGROUND_COLOR',
        'PANEL_LOGO_IMAGE_NAME',
        'PANEL_LOGO_IMAGE_URL'
      )
    }

    this.createPainelSettingsForm()

    this.filteredFontOptions = this.formSettings.get('TEXT_FONT_FAMILY')?.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value || ''))
    )
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase()
    return this.fontOptions.filter((option) => option.toLowerCase().includes(filterValue))
  }

  changeDisplayTestSrc() {
    const dimension = this.formSettings.get('TOTEM_DIMENSAO')?.value
    const callHistory = this.formSettings.get('TOTEM_HISTORY')?.value

    function getSrc() {
      if (dimension === 'auto' && callHistory === 'true')
        return '../../../assets/images/settingstest/gif-expansao-true.gif'
      if (dimension === 'auto' && callHistory === 'false')
        return '../../../assets/images/settingstest/gif-expansao-false.gif'
      if (dimension === 'fixo' && callHistory === 'true')
        return '../../../assets/images/settingstest/img-fixo-true.jpg'
      if (dimension === 'fixo' && callHistory === 'false')
        return '../../../assets/images/settingstest/img-fixo-false.jpg'

      return ''
    }

    this.displayTestSrc = getSrc()

    return ''
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.parametersResponse.forEach((item: ParameterType) => {
        const control = this.formSettings.get(item.chave!)
        if (control) {
          control.setValue(item.valor)
        }
      })
      this.changeDisplayTestSrc()
    }, 1000)

    this.getAds()
    this.getPatientQueueSettings()
    this.getSchedules()
  }

  public getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url)
  }

  getAds() {
    this.adService.getAds().forEach((element: any) => {
      if (element && element.length > 0) {
        this.ad = element[0]
      }
      this.createAdsSettingsForm()
      this.dataAvailable = true
    })
  }

  getPatientQueueSettings() {
    this.patientQueueSettingsService
      .getPatientQueueSettings()
      .subscribe((element: PatientQueueSettingsType) => {
        if (element) {
          this.patientQueueSettings = element
        }
        this.createPatientQueueSettingsForm()
        this.dataAvailable = true
      })
  }

  createAdsSettingsForm() {
    this.formAds = this.formBuilder.group({
      id: [this.ad.id ? this.ad.id : null],
      nome: [this.ad.nome, Validators.required],
      tipo: ['youtube', Validators.required],
      url: [this.ad.url, Validators.required],
      status: [this.ad.status, Validators.required],
    })
  }

  createPatientQueueSettingsForm() {
    this.formPatientQueueSettings = this.formBuilder.group({
      id: [this.patientQueueSettings.id ? this.patientQueueSettings.id : null],
      orderType: [this.patientQueueSettings.orderType ?? '1', Validators.required],
      columnType: [(this.patientQueueSettings.columnType ?? '0').toString(), Validators.required],
    })
  }

  submitAdsSettingsForm() {
    this.showSpinner = true
    if (this.formAds.valid) {
      if (this.formAds.value.id) {
        this.adService.updateAd(this.formAds.value)
      } else {
        this.adService.insertAd(this.formAds.value)
      }
    }
  }

  submitPatientQueueSettingsForm() {
    this.showSpinner = true
    if (!this.formPatientQueueSettings.valid) {
      return
    }

    if (this.formPatientQueueSettings.value.id) {
      this.patientQueueSettingsService.updatePatientQueueSettings(
        this.formPatientQueueSettings.value
      )
      return
    }

    this.patientQueueSettingsService.insertPatientQueueSettings(this.formPatientQueueSettings.value)
  }

  createPainelSettingsForm() {
    this.params.forEach((element) => {
      let value = undefined
      if (element === 'EXIBITION_TYPE') {
        value = '1'
      }
      this.formSettings.addControl(element, new FormControl(value))
    })
  }

  submitPainelSettingsForm() {
    this.showSpinner = true
    this.parameterService.updateParams(this.formSettings.value)
    this.submitAdsSettingsForm()
    this.submitPatientQueueSettingsForm()
    this.submitSchedulesSettingsForm()
    setTimeout(() => {
      this.showSpinner = false
      window.location.reload()
    }, 1000)
  }

  handleFileInputChange(files: FileList | null): void {
    if (files?.length) {
      const file = files[0]
      this.fileStore = file
      this.formSettings.get('PANEL_LOGO_IMAGE_NAME')?.setValue(file.name)
      this.handleSubmit()
    } else {
      this.fileStore = null
      console.log('Error uploading the file')
    }
  }

  handleSubmit(): void {
    if (this.fileStore) {
      const formData = new FormData()
      formData.append('upload', this.fileStore, this.fileStore.name)

      this.parameterService.uploadFile(formData).subscribe(
        (response) => {
          this.formSettings.get('PANEL_LOGO_IMAGE_URL')?.setValue(response.url)
        },
        (error) => {
          console.error('Error submitting file:', error)
        }
      )
    } else {
      console.log('No file selected.')
    }
  }

  onColorChange(event: Event, field: string): void {
    const input = event.target as HTMLInputElement
    const newValue = input.value

    if (/^#[0-9A-Fa-f]{6}$/.test(newValue)) {
      this.formSettings.get(field)?.setValue(newValue, { emitEvent: false })
    }
  }

  isAudioPlaying: boolean = false

  tryPanelAudio() {
    if (this.isAudioPlaying) return

    const callName = this.formSettings.get('SPEECH_NAME_PANEL')?.value === 'true'
    if (!callName) return

    let audio = new Audio()

    this.isAudioPlaying = true

    const prevCall = this.formSettings.get('SPEECH_PREV_PANEL')?.value
    const sayLocal = this.formSettings.get('SPEECH_LOCAL_ROOM')?.value

    console.log(prevCall)

    let callText = `${prevCall} Pedro Silva`
    if (sayLocal === 'true') {
      callText += ', guichê 3'
    }
    audio.src = this.toolsService.textToSpeech(callText)
    audio.load()
    audio.play()

    audio.onended = () => {
      this.isAudioPlaying = false
    }
  }

  getUrl(id: any) {
    return `/${this.serverUrl.getName()}/painel/${id}`
  }

  restoreAppearance() {
    this.formSettings.get('TEXT_FONT_FAMILY')?.setValue('Roboto')
    this.formSettings.get('PANEL_CLOCK_TEXT_COLOR')?.setValue('#ffffff')
    this.formSettings.get('PANEL_CLOCK_BACKGROUND_COLOR')?.setValue('#3c78b7')
    this.formSettings.get('PANEL_LOGO_IMAGE_NAME')?.setValue('otimusclinic-logo.png')
    this.formSettings.get('PANEL_LOGO_IMAGE_URL')?.setValue('assets/images/otimusclinic-logo.png')
  }

  getSchedules() {
    this.painelService.getAgendas().subscribe((resp) => {
      this.carouselSortByAppointment = resp
        .filter((schedule: any) => schedule.carouselSortType === '1')
        .sort((a: { nome: any }, b: { nome: any }) => (a.nome || '').localeCompare(b.nome || ''));
  
      this.carouselSortByCheckin = resp
        .filter((schedule: any) => schedule.carouselSortType === '2')
        .sort((a: { nome: any }, b: { nome: any }) => (a.nome || '').localeCompare(b.nome || ''));
    })
  }
  
  addSchedules(type: 'appointment' | 'checkin') {
    if (type === 'appointment') {
      if (!this.selectedAppointmentSchedules || !this.selectedAppointmentSchedules.length) return

      this.selectedAppointmentSchedules.forEach(schedule => {
        this.carouselSortByAppointment.push(schedule)
  
        this.carouselSortByCheckin = this.carouselSortByCheckin.filter(
          item => item.id !== schedule.id
        )
      })
  
      this.carouselSortByAppointment.sort((a, b) => (a.nome || '').localeCompare(b.nome || ''))
      this.selectedAppointmentSchedules = []
    } else {
      if (!this.selectedCheckinSchedules || !this.selectedCheckinSchedules.length) return

      this.selectedCheckinSchedules.forEach(schedule => {
        this.carouselSortByCheckin.push(schedule)

        this.carouselSortByAppointment = this.carouselSortByAppointment.filter(
          item => item.id !== schedule.id
        )
      })

      this.carouselSortByCheckin.sort((a, b) => (a.nome || '').localeCompare(b.nome || ''))
      this.selectedCheckinSchedules = []
    }
  }

  submitSchedulesSettingsForm() {
    this.painelService.updateCarouselSortType(
      this.carouselSortByAppointment,
      this.carouselSortByCheckin
    ).subscribe({
      next: (resp) => {
      },
      error: (err) => {
      }
    })
  }  
}
